import { injectBetData } from "@fresh8/ad-data-composition/src/betData";
import { AnalyticEvents } from "@fresh8/types/src/analytics";
interface PixelMacros {
  sport?: string;
  marketId?: string;
  eventName?: string;
  eventId?: string;
  competitor?: string;
  competition?: string;
}

export function usePixelMacros() {
  const betData = injectBetData();

  const getPixelMacroData = ({
    marketId,
    eventId
  }: {
    marketId?: string;
    eventId?: string;
  }): PixelMacros | null => {
    const market =
      marketId && betData?.markets.value
        ? betData.markets.value[marketId]
        : null;
    const event = market
      ? betData?.events.value[market.eventId]
      : eventId
      ? betData?.events.value[eventId]
      : null;

    if (!market || !event) {
      return null;
    }

    return {
      sport: event?.sport,
      marketId: market?.marketId,
      eventName: event?.name,
      eventId: market?.eventId,
      competitor:
        event?.competitors?.home && event?.competitors?.away
          ? event.competitors.home.name.full +
            "," +
            event.competitors.away.name.full
          : undefined,
      competition: event?.competition
    };
  };

  const getPixelUrl = (eventName: AnalyticEvents): string | undefined => {
    let pixelUrl;

    if (betData?.pixels.value && eventName === AnalyticEvents.CLICKED_THROUGH) {
      pixelUrl = betData.pixels.value.clickThrough;
    }
    if (betData?.pixels.value && eventName === AnalyticEvents.VIEWED) {
      pixelUrl = betData.pixels.value.impression;
    }

    return pixelUrl;
  };

  const populatePixelUrl = (
    pixelMacroData: PixelMacros,
    pixelUrl: string
  ): string => {
    if (pixelMacroData.sport) {
      pixelUrl = pixelUrl.replace("{sport}", pixelMacroData.sport);
    }
    if (pixelMacroData.marketId) {
      pixelUrl = pixelUrl.replace("{marketID}", pixelMacroData.marketId);
    }
    if (pixelMacroData.eventName) {
      pixelUrl = pixelUrl.replace("{eventName}", pixelMacroData.eventName);
    }
    if (pixelMacroData.eventId) {
      pixelUrl = pixelUrl.replace("{eventID}", pixelMacroData.eventId);
    }
    if (pixelMacroData.competitor) {
      pixelUrl = pixelUrl.replace("{competitor}", pixelMacroData.competitor);
    }
    if (pixelMacroData.competition) {
      pixelUrl = pixelUrl.replace("{competition}", pixelMacroData.competition);
    }
    return pixelUrl;
  };

  return {
    getPixelUrl,
    getPixelMacroData,
    populatePixelUrl
  };
}
